import provider from '@/api/apollo-client';
import schema from '@/services/datatypes/schema.graphql';

const load = data => {
  return provider.query({
    query: schema.getDataTypes,
    variables: {
      input: data
    },
    fetchPolicy: 'no-cache'
  });
};

const create = data => {
  return provider.mutate({
    mutation: schema.createDataType,
    variables: {
      input: data
    },
    fetchPolicy: 'no-cache'
  });
};

const update = data => {
  return provider.mutate({
    mutation: schema.updateDataType,
    variables: {
      input: data
    },
    fetchPolicy: 'no-cache'
  });
};

const remove = id => {
  return provider.mutate({
    mutation: schema.deletePropertyType,
    variables: {
      input: {
        id
      }
    },
    fetchPolicy: 'no-cache'
  });
};

const getOneDataType = id => {
  return provider.query({
    query: schema.getOneDataType,
    variables: {
      id
    },
    fetchPolicy: 'no-cache'
  });
};

export default {
  load,
  create,
  update,
  getOneDataType,
  remove
};
